import React from 'react'
import { Link } from 'react-router-dom'
import MessageUtils from '../../../util/MessageUtils'
import AvatarUI from '../../../widgets/output/AvatarUI'
import './RowRight.css'

const RowRightUI = ({context, messageList, task, moveMode, projectUserMap}) =>
  <React.Fragment>
    {
      task.priority &&
      <div className={`priority ${task.priority} tag`}>
        {task.priority}
      </div>
    }
    {
      projectUserMap && task.userId &&
      <AvatarUI
        avatarUrl={projectUserMap[task.userId] ? projectUserMap[task.userId].avatarUrl : null}
        userName={task.userName}
        userLeft={task.userLeft}
      />
    }
    {
      moveMode &&
      <div className='icon icon-arrows move tag' data-task-id={task.taskId}></div>
    }
    {
      !moveMode &&
      <Link className='icon icon-caret-right tag' to={`/tasks/${task.taskNumber}`}
        title={MessageUtils.getMessageValue(messageList, 'c_invite_user')}>
      </Link>
    }
  </React.Fragment>

export default RowRightUI
